import axios from 'axios'
import { stringify } from 'qs'
import { installAuthInterceptors } from './apiInterceptors'
import * as session from './authSession'

const api = axios.create({
	baseURL: process.env.VUE_APP_API,
	paramsSerializer: params => stringify(params),
})

installAuthInterceptors(api, session)

export default api
